export enum UserRole {
    superadmin = 1,
    admin = 2,
    user = 3,
    employee = 4
  }